import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AdminProfile from 'views/AdminProfile/AdminProfile';
import Complaint from 'views/Complaint';
import Laundary from 'views/Laundary';
import ReservationDashboard from 'views/Reservation/Components/ReservationDashboard';
import Food from 'views/ReservationFood/index';
import ComplaintDashboard from 'views/Complaint/ComplaintDashboard';
import Customer from 'views/Customer';
import CustomerDashboard from 'views/Customer/Components';
import HotelProfile from 'views/HotelProfile/hotelProfile';
import MainDashboard from 'views/mainDashboard/Default';
import HotelManagement from 'views/HotelManagement';
import HotelManagementDashboard from 'views/HotelManagement/Components';
import StaffManagment from 'views/Staff';
import Restaurant from 'views/restaurant';
import EmployeeDashboard from 'views/Staff/Components';
import AdminComplaint from 'views/AdminComplaint';
import AdminComplaintDashboard from 'views/AdminComplaint/ComplaintDashboard';
import AdminDashboard from 'views/AdminDashboard';
import AdminReports from 'views/Adminreports';
import AdminPackages from 'views/AdminSubscriptions';
import AdminPayments from 'views/AdminPayments';
import AdminPaymentGateways from 'views/AdminPaymentGateways';
import AdminPlatformPromoCodes from 'views/AdminPlatformPromoCodes';
import AdminApiKeys from 'views/AdminApiKeys';
import PackagesDashboard from 'views/AdminSubscriptions/Components/PackagesDashboard';
import HotelSubscriptionsDetails from 'views/HotelSubscriptions';
import HotelPaymentsDetails from 'views/HotelPayments';
import HotelPaymentsStripeSuccess from 'views/HotelPaymentsStripeSuccess';
import VisitorDashboard from 'views/VisitorInformation/Components';
import SeparateFoodView from 'views/SeparateFoodOrder/FoodView';

import PoliceReports from 'views/dashboard/PoliceReports';
import GeneralReports from 'views/dashboard/GeneralReports';
import KotReports from 'views/dashboard/KotReports';
import CustomerBookingHistory from 'views/Customer/Components/CustomerBookingHistory';

import ViewInvoices from 'views/Invoices';
import ExchangeRate from 'views/exchangeRate/ExchangeRate';

import OpenCashRegister from 'views/dashboard/cashregister/OpenCashRegister';
import CloseCashRegister from 'views/dashboard/cashregister/CloseCashRegister';

import CashRegisterReport from 'views/Reports/CashRegisterReport';
const CashCustody = Loadable(lazy(() => import('views/Reports/CashCustody'))); // 💰 Custodia de efectivo del gerente
const ChartOfAccounts = Loadable(lazy(() => import('views/Accounting/ChartOfAccounts'))); // 📒 Plan de cuentas
const AccountingReports = Loadable(lazy(() => import('views/Accounting/AccountingReports'))); // 📊 Reportes contables
const Vouchers = Loadable(lazy(() => import('views/Accounting/Vouchers'))); // 🧾 Vouchers manuales
import HousekeepingPanel from 'views/Room/HousekeepingPanel';
import PreReservation from '../views/preReservation';
import WhatsAppConfiguration from 'views/WhatsApp/WhatsAppConfiguration';
import RoomsCalendar from 'views/Calendar/RoomsCalendar';
import RoomsCalendarLite from 'views/Calendar/RoomsCalendarLite';
import MetricsDashboard from 'views/MetricsDashboard';
import TasksPage from 'views/Tasks';
import ReserveRoom from 'views/Room/ReserveRoom';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const RoomManagement = Loadable(lazy(() => import('views/Room')));
const Reservation = Loadable(lazy(() => import('views/Reservation')));
const Expenses = Loadable(lazy(() => import('views/Expenses')));
const ExpenseCategories = Loadable(lazy(() => import('views/ExpenseCategories')));
const Suppliers = Loadable(lazy(() => import('views/Suppliers')));
const Departments = Loadable(lazy(() => import('views/Departments')));
const Inventory = Loadable(lazy(() => import('views/Inventory')));
const KitchenOrderTicket = Loadable(lazy(() => import('views/KitchenOrderTicket')));
const Conversations = Loadable(lazy(() => import('views/dashboard/conversations')));
const WhatsAppMetrics = Loadable(lazy(() => import('views/dashboard/whatsappMetrics')));
const RoomTypes = Loadable(lazy(() => import('views/Settings/RoomTypes')));
const StayTypes = Loadable(lazy(() => import('views/Settings/StayTypes')));
const RateMatrix = Loadable(lazy(() => import('views/Settings/Rates')));
const PromoCodes = Loadable(lazy(() => import('views/PromoCodes')));
const SegoIAConfiguration = Loadable(lazy(() => import('views/AdminSegoIA/SegoIAConfiguration'))); // 🤖 SEGO IA GLOBAL CONFIG
const AdminSegoIADialogues = Loadable(lazy(() => import('views/AdminSegoIADialogues/index'))); // 💬 SEGO IA DIALOGUES
const Maintenance = Loadable(lazy(() => import('views/Maintenance'))); // 🛠️ MANTENIMIENTO
const MaintenanceReports = Loadable(lazy(() => import('views/Maintenance/MaintenanceReports'))); // 📊 KPIs MANTENIMIENTO
const MaintenanceTemplates = Loadable(lazy(() => import('views/Maintenance/Templates'))); // 📋 PLANTILLAS
const MaintenanceAssets = Loadable(lazy(() => import('views/Maintenance/Assets'))); // 🔧 ACTIVOS
const MaintenancePreventive = Loadable(lazy(() => import('views/Maintenance/Preventive'))); // 🔄 PREVENTIVO
const MaintenanceChecklistRunner = Loadable(lazy(() => import('views/Maintenance/ChecklistRunner'))); // ✅ CHECKLIST
const MaintenanceCommonAreas = Loadable(lazy(() => import('views/Maintenance/CommonAreas'))); // 🏛️ ÁREAS COMUNES
const SegoIntegrationPage = Loadable(lazy(() => import('views/Integrations/SegoIntegration'))); // 🔗 INTEGRATIONS — Conectar Sego
const ExecutiveDashboardPage = Loadable(lazy(() => import('views/Integrations/ExecutiveDashboard'))); // 📊 INTEGRATIONS — Dashboard ejecutivo

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    { path: '/housekeeping', element: <HousekeepingPanel /> },
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'integrations/sego',
          element: <SegoIntegrationPage />
        },
        {
          path: 'executive',
          element: <ExecutiveDashboardPage />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'app',
          element: <MainDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'roommanagement',
          element: <RoomManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'reservation',
          element: <Reservation />
        },
        {
          path: 'reservation/reserve-room/:roomNo?',
          element: <ReserveRoom />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'exchangerate',
          element: <ExchangeRate />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/calendar',
          element: <RoomsCalendarLite />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/metrics',
          element: <MetricsDashboard />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'staffmanagement',
          element: <StaffManagment />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'customers',
          element: <Customer />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'expenses',
          element: <Expenses />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'expense-categories',
          element: <ExpenseCategories />
        },
        {
          path: 'suppliers',
          element: <Suppliers />
        },
        {
          path: 'departments',
          element: <Departments />
        },
        {
          path: 'inventory',
          element: <Inventory />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'pre-reservations',
          element: <PreReservation />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'conversations',
          element: <Conversations />
        },
        {
          path: 'whatsapp-metrics',
          element: <WhatsAppMetrics />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'Whatsappconfig',
          element: <WhatsAppConfiguration />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'kot',
          element: <KitchenOrderTicket />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'restaurant',
          element: <Restaurant />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'complaint',
          element: <Complaint />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'laundary',
          element: <Laundary />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'reports',
          element: <DashboardDefault />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'policyreports',
          element: <PoliceReports />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'generalreport',
          element: <GeneralReports />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'kotreports',
          element: <KotReports />
        }
      ]
    },
    {
      path: '/dashboard/cashregister/open',
      element: <OpenCashRegister />
    },
    {
      path: '/dashboard/cashregister/close',
      element: <CloseCashRegister />
    },
    {
      path: 'cashregister-report',
      element: <CashRegisterReport />
    },
    {
      path: '/dashboard/cash-custody',
      element: <CashCustody />
    },
    {
      path: '/dashboard/chart-of-accounts',
      element: <ChartOfAccounts />
    },
    {
      path: '/dashboard/accounting-reports',
      element: <AccountingReports />
    },
    {
      path: '/dashboard/vouchers',
      element: <Vouchers />
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/reservation/addfood/:id',
          element: <Food />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/separatefood/addfood',
          element: <SeparateFoodView />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/lead/view/:id',
          element: <RoomManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/customer/view/:id',
          element: <CustomerDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/customer/view/specificbooking/:id',
          element: <CustomerBookingHistory />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/employee/view/:id',
          element: <EmployeeDashboard />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/complaint/view/:id',
          element: <ComplaintDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/reservation/view/:id',
          element: <ReservationDashboard />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotel',
          element: <HotelManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotel/view/:id',
          element: <HotelManagementDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'profile',
          element: <HotelProfile />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'tasks',
          element: <TasksPage />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'maintenance',
          element: <Maintenance />
        },
        {
          path: 'maintenance/reports',
          element: <MaintenanceReports />
        },
        {
          path: 'maintenance/templates',
          element: <MaintenanceTemplates />
        },
        {
          path: 'maintenance/assets',
          element: <MaintenanceAssets />
        },
        {
          path: 'maintenance/preventive',
          element: <MaintenancePreventive />
        },
        {
          path: 'maintenance/checklist/:id',
          element: <MaintenanceChecklistRunner />
        },
        {
          path: 'maintenance/common-areas',
          element: <MaintenanceCommonAreas />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'invoice',
          element: <ViewInvoices />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'adminprofile',
          element: <AdminProfile />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'admincomplaint',
          element: <AdminComplaint />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/admincomplaint/view/:id',
          element: <AdminComplaintDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'admin-sego-ia',
          element: <SegoIAConfiguration />
        },
        {
          path: 'admin-sego-ia-dialogues',
          element: <AdminSegoIADialogues />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/admindashboard',
          element: <AdminDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/adminreports',
          element: <AdminReports />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/subscriptions',
          element: <AdminPackages />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotelsubscriptions',
          element: <HotelSubscriptionsDetails />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/settings/room-types',
          element: <RoomTypes />
        },
        {
          path: '/dashboard/settings/stay-types',
          element: <StayTypes />
        },
        {
          path: '/dashboard/settings/rates',
          element: <RateMatrix />
        },
        {
          path: '/dashboard/settings/promo-codes',
          element: <PromoCodes />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/payments',
          element: <AdminPayments />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/payment-gateways',
          element: <AdminPaymentGateways />
        },
        {
          path: '/dashboard/promo-codes',
          element: <AdminPlatformPromoCodes />
        },
        {
          path: '/dashboard/api-keys',
          element: <AdminApiKeys />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotelpayments',
          element: <HotelPaymentsDetails />
        },
        {
          path: '/dashboard/hotelpayments/stripe-success',
          element: <HotelPaymentsStripeSuccess />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/packages/view/:id',
          element: <PackagesDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/visitor/view/:phone',
          element: <VisitorDashboard />
        }
      ]
    }
  ]
};

export default MainRoutes;
